const staticPixels = "<script>window.googleTagManagerActive = true; window.dataLayer = window.dataLayer || []; window.gtag = function() { dataLayer.push(arguments); };</script>";

export { staticPixels };